import Model from '../Model';
import Mithril from 'mithril';
import HeroTagHeroLevel from './HeroTagHeroLevel';


export default class HeroTagHeroIntro extends Model {
  latestDataId() {
    return Model.attribute<number>('latestDataId').call(this);
  }
  skillName() {
    return Model.attribute<string>('skillName').call(this);
  }
  skillImg() {
    return Model.attribute<string>('skillImg').call(this);
  }
  skillEffect() {
    return Model.attribute<string>('skillEffect').call(this);
  }
  skillType() {
    return Model.attribute<string>('skillType').call(this);
  }
  skillIntro() {
    return Model.attribute<string>('skillIntro').call(this);
  }
  sort() {
    return Model.attribute<number>('sort').call(this);
  }
  heroTagHeroLevel() {
    return Model.hasMany<HeroTagHeroLevel>('heroTagHeroLevel').call(this);
  }

}
